const config = {
  BASE_URL: process.env.BASE_URL || 'https://app.terrenum.com.ar/api/',
  DESCRIPCION: process.env.DESCRIPCION || 'Estudio Agrimensura',
  AUTOR: process.env.AUTOR || 'Archer',
  VERSION: process.env.VERSION || '1.0.0',
  NOMBRE: process.env.NOMBRE || 'Agrimensura Panel Cliente',
};

export default config;


// WEBPACK FOOTER //
// ./src/config/index.js